import Loader from 'components/miscellaneous/Loader/Loader';
import api from 'helpers/api';
import { useEffect, useState } from 'react';
import AliceCarousel from "react-alice-carousel";
import 'react-alice-carousel/lib/alice-carousel.css';
import style from './ClinicUsageWidget.module.scss'
import PlatformUsagePieChart from "components/PlatformUsagePieChart/PlatformUsagePieChart";
import { $t } from 'helpers/translator';

const ClinicUsageWidget = ({dateRange}) => {
    const { startDate, endDate } = dateRange;
    const [ clinics, setClinics ] = useState([]);
    const [ cards, setCards ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(true);

    useEffect(() => {
        getData()
    }, [dateRange])

    useEffect(() => {
        if(clinics.length > 0) {
            loadClinicCards()
        }
    }, [clinics])

    const getData = async() => {
        setIsLoading(true);
        try {
            const res = await api.get(`/dashboard/clinics/usage?startDate=${startDate}&endDate=${endDate}`);
            setClinics(res.data.data);
        } catch(e) {

        } finally {
            setIsLoading(false);
        }
    }

    const loadClinicCards = () => {
        let cardsArray = [];
        clinics.forEach((clinic, index) => {
            cardsArray.push(
                <div className={style.cardContainer} style={{margin: 0}} key={index}>
                    <div className={style.clinicHeader}>
                        <div className={style.clinicName}>{clinic.clinic_name}</div>
                        <div style={{marginLeft: 'auto'}}>{clinic.clinic_platforms} Platforms</div>
                    </div>
                    <div className='d-flex align-items-center'>
                        <div className={style.usageData}>
                            <div>
                                <span>{getTranslation('online')}</span>
                                <h3 style={{color: '#473073'}}>{getStatHours(clinic.usage, 'online')}</h3>
                            </div>
                            <div>
                                <span>{getTranslation('treatment')}</span>
                                <h3 style={{color: '#319aa1'}}>{getStatHours(clinic.usage, 'treatment')}</h3>
                            </div>
                            <div>
                                <span>{getTranslation('lasing')}</span>
                                <h3 style={{color: '#f7c59f'}}>{getStatHours(clinic.usage, 'lasing')}</h3>
                            </div>

                        </div>
                        <div className={style.usageGraph}>
                        <PlatformUsagePieChart size={175} data={{
                            lasing: clinic.usage.percentage.lasing,
                            treatment: clinic.usage.percentage.treatment,
                            online: clinic.usage.percentage.online,
                        }}/>
                        </div>
                    </div>
                </div>
            )
        })

        setCards(cardsArray);
    }

    const getStatHours = (usage, stat) => {
        let times = usage?.time;
  
        if(times) {
            if(times[stat]) {
                const hours = times[stat] / 60 / 60;
                if(hours > 1) {
                    if(hours < 10000) {
                        const hoursTranslation = $t('global.dateTime.hours');
                        return hours.toFixed(2) + ' ' + hoursTranslation;
                    } else {
                        const days = hours / 24;
                        const daysTranslation = $t('global.dateTime.days');
                        return days.toFixed(2) + ' ' + daysTranslation;
                    }
                } else {
                    const minutes = times[stat] / 60;
                    if(minutes > 0) {
                        const minutesTranslation = $t('global.dateTime.minutes');
                        return minutes.toFixed(2) + ' ' + minutesTranslation;
                    } else {
                        return $t('global.machines.pieChart.noActivity')
                    }
                }
            } else {
                return $t('global.machines.pieChart.noActivity')
            }
        }
    }

    const getTranslation = (key) => {
        const t = $t(`global.machines.pieChart.${key}`);
        return t.split('/')[0].split(' + ')[0];
    }


    return (
        <>
            {!isLoading ? <>
                <AliceCarousel
                    mouseTracking
                    items={cards}
                    responsive={{
                        0: {items: 1},
                    }}
                    disableButtonsControls={false}
                    disableDotsControls={true}
                    keyboardNavigation={true}
                />
            </> : <div className='d-flex h-100 align-items-center justify-content-center'><Loader color="#ddd" /></div>}
        </>
    )
}

export default ClinicUsageWidget;